import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import './HomeWorldMap.css'

export default function HomeWorldMap({ stats, territories = [] }) {
  const atWar = useMemo(
    () => (territories || []).filter((t) => t.territory_status === 'Guerra').length,
    [territories]
  )
  const total = territories?.length || stats?.territories || 0

  return (
    <section className="home-world-map" aria-label="Mapa del mundo">
      <div
        className="home-world-map__bg"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/map.jpg)` }}
        aria-hidden="true"
      />
      <div className="home-world-map__overlay" aria-hidden="true" />

      <div className="home-world-map__content">
        <div className="home-world-map__text">
          <span className="home-world-map__eyebrow">図 · Cartografía</span>
          <h2 className="home-world-map__title">Mapa del Mundo</h2>
          <p className="home-world-map__description">
            Explora la geografía del mundo shinobi. Territorios, rutas y zonas en conflicto.
          </p>
        </div>

        <div className="home-world-map__meta">
          {total > 0 && (
            <div className="home-world-map__stat">
              <span className="home-world-map__stat-icon">⛩</span>
              <span className="home-world-map__stat-value">{total}</span>
              <span className="home-world-map__stat-label">territorios</span>
            </div>
          )}
          {atWar > 0 && (
            <div className="home-world-map__stat home-world-map__stat--war">
              <span className="home-world-map__stat-icon">⚔</span>
              <span className="home-world-map__stat-value">{atWar}</span>
              <span className="home-world-map__stat-label">en conflicto</span>
            </div>
          )}
        </div>

        <Link to="/mapa" className="home-world-map__cta">
          <span>Ver mapa completo</span>
          <span className="home-world-map__cta-arrow" aria-hidden="true">→</span>
        </Link>
      </div>
    </section>
  )
}
